import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { TranslateResult } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsButtonBlock',
  props: {
  title: { type: [String, Object] as PropType<string|TranslateResult>, required: true },
  description: { type: [String, Object] as PropType<string|TranslateResult>, required: true },
  contentClass: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: 'pa-3' },
},
  setup(__props) {

const props = __props;




return { __sfc: true,props }
}

})